import { getDeepLinkProtocol } from '@/utils/platform';

// Keep in sync with getDeepLinkProtocol and AppConfig.getDeepLinkProtocol
const RELEASED_DESKTOP_PROTOCOLS: ReadonlySet<string> = new Set([
  'little-bird',
  'little-bird-staging',
  'little-bird-experimental',
]);

export function isAllowedDeepLinkProtocol(candidate: string): boolean {
  return (
    RELEASED_DESKTOP_PROTOCOLS.has(candidate) ||
    candidate === getDeepLinkProtocol()
  );
}

export function resolveDeepLinkProtocol(
  candidate: string | null | undefined
): string | null {
  if (!candidate) return null;
  return isAllowedDeepLinkProtocol(candidate) ? candidate : null;
}
